import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { RaDashboardService } from './../ra.dashboard.service';

@Component({
  selector: 'ra-widget-container',
  templateUrl: './ra.widget.container.component.html',
  styleUrls: ['./ra.widget.container.component.css']
})
export class RAWidgetContainer implements OnInit {
  constructor(private dashboardService: RaDashboardService) {

  }
  @ViewChild('ctlWidget') ctlWidget :ElementRef;
  @Input() widgetId: number;
  @Input() globalFilter: any;

  @Input() data: any;

  ngOnInit() {
    this.loadWidget(this.data);
  }


  public editWidget() {

  }
  public deleteWidget() {

  }
  public moveWidget() {

  }
  public copyWidget() {

  }
  public collapse() {

  }
  public configChangeEventHandler(e) {

  }
  public globalFilterChangeEventHandler(e) {

  }

  /// To load external custom element to the widget container
  loadWidget(data:any) {   
    this.dashboardService.loadExternalScript(data.widgetInfo.scriptUrl);
    var widgetElement = document.createElement(data.widgetInfo.customTag);
    this.ctlWidget.nativeElement.append(data.widgetElement);
  }

}
